/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IActiveImageAdditionalContentViewProps } from '@msdyn365-commerce-modules/active-image/src/modules/active-image/../active-image-utilities';
import { IActiveImageViewProps } from '@msdyn365-commerce-modules/active-image/src/modules/active-image/./active-image';

/**
 * Render Additional Content.
 * @param additionalContent - Additional content view props.
 * @returns JSX Element.
 */
const renderAdditionalContent = (additionalContent: IActiveImageAdditionalContentViewProps) => {
    return (
        <Node {...additionalContent.additionalContentNode}>
            {additionalContent.heading}
            <Node {...additionalContent.additionalContentContainer}>
                {additionalContent.text}
                <Node {...additionalContent.additionalContentItemLinks}>
                    {additionalContent.links}
                </Node>
            </Node>
        </Node >
    );
};

/**
 * Render View.
 * @param props - The view props.
 * @returns -The JSX Element.
 */
export const activeImageView: React.FC<IActiveImageViewProps> = props => {
    return (
        <Module {...props.activePointContainer}>
            <Node {...props.activePointDetailsContainer}>
                {props.imageMapper}
                <Node {...props.detailsContainer} className={props.detailsContainer ? props.detailsContainer.className : ''}>
                    {props.title}
                    {props.text}
                    {props.additionalContent && renderAdditionalContent(props.additionalContent)}
                    <Node {...props.detailsContainerCta} className={props.detailsContainerCta ? props.detailsContainerCta.className : ''}>
                        {props.links}
                    </Node>
                </Node>
            </Node>
            <Node
                className='msc-active-image-product-card-container'
                style={{ top: `${props.productCardtopPosition}px`, left: `${props.productCardleftPosition}px` }}>
                {props.overlay}
                {props.productCard}
            </Node>
        </Module>
    );
};

export default activeImageView;
